import { Component, OnInit, Input, Output, ViewChild } from '@angular/core';
import {Router} from '@angular/router';
import { NgForm, FormControl } from '@angular/forms';

import { otpDetails } from '../../interfaces';
import { SnackService } from '../../services';
import { AuthService } from '../../api';



@Component({
  selector: 'school-twofa-ui',
  templateUrl: './twofa-ui.component.html',
  styleUrls: ['./twofa-ui.component.scss']
})
export class TwofauiComponent implements OnInit {

  public error: string;
  isLoading: boolean;
  @Input() usertype: any;
  @Input() cancellink: any;
  @Input() issubmitlink: any;
  @ViewChild("twofapasswordform", { static: false }) twofapasswordsform: NgForm;
  twoFaValue = {} as otpDetails;

  username : string;
  login_details : any;

  constructor(
    private _snackService: SnackService,
    private authService: AuthService,
    private route:Router) {
    this.route.getCurrentNavigation().extras.state.example
    const navigation = this.route.getCurrentNavigation();
    this.login_details = navigation.extras.state as {
      username: string,
      password: string
    };
  }

  

  ngOnInit(): void {
    this.twoFaValue = this.login_details;
    // console.log(this.login_details);
  }
  
  onSubmit_old(){
    this.route.navigate([`/${this.issubmitlink}`]);
  }

  onSubmit(){

    if(!this.twoFaValue.otp){
      // this.error = "Please enter email";
      this.isLoading = false;
      this._snackService.openSnackBar("danger", "Enter OTP");
      return false;
    }

    this.twoFaValue.role = this.usertype;
    this.twoFaValue.action = "2faAuthentication";
    this.twoFaValue.verify_mode = "phone";

    const saveData = { ...this.twoFaValue };
    console.log(saveData);

    this.authService.otpVerify(saveData).subscribe(resData => {
      console.log(resData,' resData--');
      // console.log(resData.body,' resData');      
      this._snackService.openSnackBar("success", resData.body.data.message);
      // this.route.navigate([this.dashboardLink]);
      
      this.twofapasswordsform.resetForm();
      this.route.navigate([`/${this.issubmitlink}`]);
    },
    error => {
      this.error = error;
      this.isLoading = false;
    });
  }
  
  
  cancel(){
    this.route.navigate([`/${this.cancellink}`]);
  }

}
